module.exports = __webpack_public_path__ + "assets/95f8d318e77f06ba99efb8427b8fbcf8.ttf";